module.exports = __webpack_public_path__ + "img/tools_legislation2.fcca06b6.jpg";